import { render } from "./BemVindo.vue?vue&type=template&id=09049460&scoped=true"
import script from "./BemVindo.vue?vue&type=script&lang=js"
export * from "./BemVindo.vue?vue&type=script&lang=js"

import "./BemVindo.vue?vue&type=style&index=0&id=09049460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09049460"]])

export default __exports__